import { Card as BootstrapCard, Button } from 'react-bootstrap';
import { ReactNode } from 'react';

interface CardProps {
  image: string;
  title: ReactNode;
  body: ReactNode;
  buttonText?: ReactNode;
  buttonLink?: string;
  className?: string;
  alt?: string;
}

const Card = ({ image, title, body, buttonText, buttonLink, className = '', alt }: CardProps) => {
  const imageAlt = alt || (typeof title === 'string' ? title : 'Card image');
  return (
    <BootstrapCard className={className}>
      <BootstrapCard.Img variant="top" src={image} alt={imageAlt} />
      <BootstrapCard.Body className="text-center d-flex flex-column align-items-center justify-content-center">
        <BootstrapCard.Title>{title}</BootstrapCard.Title>
        <BootstrapCard.Text>{body}</BootstrapCard.Text>
        {buttonText && (
          <Button variant="outline-dark" href={buttonLink || '#'}>
            {buttonText}
          </Button>
        )}
      </BootstrapCard.Body>
    </BootstrapCard>
  );
};

export default Card;
